import { Button, Icons, Typography, Stack } from '@cast/design-system';

import { useTourV2 } from 'core/tour-v2/TourProvider';

type Props = {
  noBack?: boolean;
};

export function TourStepToolbar(props: Props) {
  const tour = useTourV2();
  const stepsWithTooltips = tour.allSteps.filter((step) => !!step.tooltip);
  const currentIndex = tour.currentStep?.id
    ? stepsWithTooltips.findIndex((step) => step.id === tour.currentStep?.id)
    : -1;

  const showBack = !props.noBack;

  return (
    <Stack
      justifyContent={showBack ? 'space-between' : 'flex-end'}
      direction="row"
      color="grey.400"
      mb={4}
    >
      {!props.noBack && (
        <Button
          startIcon={<Icons.CaretLeft />}
          variant="text"
          size="sm"
          sx={{
            color: 'inherit',
            '&:hover': {
              color: 'grey.300',
            },
          }}
          onClick={tour.api.prev}
          testId="back-btn"
        >
          Back
        </Button>
      )}

      {currentIndex >= 0 && !!stepsWithTooltips.length && (
        <Typography variant="P10R" data-testid="step-index">
          {currentIndex + 1} of {stepsWithTooltips.length}
        </Typography>
      )}
    </Stack>
  );
}
